import bannerImg from './banners/woman-helping-man-gym.jpg';

const anamneseFitnessCompleta = (t) => ({
    id: 'anamnese-fitness-completa',
    title: t('templates.items.anamneseFitnessCompleta.title'),
    description: t('templates.items.anamneseFitnessCompleta.description'),
    indicatedFor: t('templates.audiences.personalTrainers'),
    stepsCount: 3,
    questionsSummary: [
        t('templates.items.anamneseFitnessCompleta.summary.medicalHistory'),
        t('templates.items.anamneseFitnessCompleta.summary.lifestyle'),
        t('templates.items.anamneseFitnessCompleta.summary.goals'),
        t('templates.items.anamneseFitnessCompleta.summary.bodyComposition'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.anamneseFitnessCompleta.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.anamneseFitnessCompleta.form.personal.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.anamneseFitnessCompleta.form.personal.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.anamneseFitnessCompleta.form.personal.fullName.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'gender',
                        label: t('templates.items.anamneseFitnessCompleta.form.personal.gender.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'body_structure',
                        label: t('templates.items.anamneseFitnessCompleta.form.personal.bodyStructure.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'weight',
                        label: t('templates.items.anamneseFitnessCompleta.form.personal.currentWeight.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
            {
                order: 2,
                title: t('templates.items.anamneseFitnessCompleta.form.health.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.anamneseFitnessCompleta.form.health.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'yes_no_maybe',
                        label: t('templates.items.anamneseFitnessCompleta.form.health.chronicDisease.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'yes_no_maybe',
                        label: t('templates.items.anamneseFitnessCompleta.form.health.medication.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: t('templates.items.anamneseFitnessCompleta.form.health.injury.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
            {
                order: 3,
                title: t('templates.items.anamneseFitnessCompleta.form.lifestyle.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.anamneseFitnessCompleta.form.lifestyle.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'choices',
                        label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.mainGoal.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.mainGoal.options.loseWeight') },
                                { id: 'opt-2', label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.mainGoal.options.gainMuscle') },
                                { id: 'opt-3', label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.mainGoal.options.conditioning') },
                                { id: 'opt-4', label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.mainGoal.options.wellbeing') },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'choices',
                        label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.sleep.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.sleep.options.lessThanSix') },
                                { id: 'opt-2', label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.sleep.options.sixToSeven') },
                                { id: 'opt-3', label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.sleep.options.sevenToEight') },
                                { id: 'opt-4', label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.sleep.options.moreThanEight') },
                            ],
                        },
                    },
                    {
                        order: 3,
                        type: 'scale',
                        label: t('templates.items.anamneseFitnessCompleta.form.lifestyle.stress.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.anamneseFitnessCompleta.form.lifestyle.stress.minLabel'),
                            maxLabel: t('templates.items.anamneseFitnessCompleta.form.lifestyle.stress.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default anamneseFitnessCompleta;
